export function parseMainNumbers(result: string | null | undefined): number[] {
  if (!result) return [];
  try {
    const arr = JSON.parse(result);
    return Array.isArray(arr[0]) ? arr[0] : [];
  } catch {
    return [];
  }
}

export function parseBonusNumbers(result: string | null | undefined): number[] {
  if (!result) return [];
  try {
    const arr = JSON.parse(result);
    return Array.isArray(arr[1]) ? arr[1] : [];
  } catch {
    return [];
  }
}

export function getGameLogoUrl(gameLogo: string | null | undefined): string {
  return `/img/flags/${gameLogo}`;
} 

export function formatDrawTime(dateStr: string): string {
  if (!dateStr) return '';
  const date = new Date(dateStr.replace(' ', 'T'));
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  return `${day}/${month}/${year}, ${hours}:${minutes}`;
}
